/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {editV2Goal} from '../api'

export const useMutationEditV2Goal = createReactQueryMutationHook('editV2Goal', editV2Goal)
